export default __webpack_public_path__ + "static/media/5_2x2.2e852f66.jpg";